<mat-card [routerLink]="link">
  <div class="selectTopic">
    <img *ngIf="imageUrl" mat-card-image [src]="imageUrl">
  </div>
  <h4 class="title text-center">{{title}}</h4>
</mat-card>